module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921083834_T.7d70e6f4.jpg";